/**
 * This file is auto-generated from FormFieldWrapper.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const optional: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'optional';
        case 'pl':
            return 'opcjonalne';
    }
};
